(function () {

  'use strict';

  function pxCopilotDirective(
    $filter, $location, $rootScope, $timeout, $window, CopilotService, EnumerationService, CopilotConstants, TenantListService
  ) {
    return {
      restrict: 'EA',
      scope: {
        context: '=context',
        tenant: '=tenant',
        meta: '=meta',
        callback: '&callback'
      },
      templateUrl: 'app/directives/copilot/copilot.template.html',
      link: function (scope, element) {

        scope.me = $rootScope.currentUser;

        scope.userFirstName = null;
        scope.userInitials = null;
        scope.showChatWait = false;
        scope.showMoreButton = false;
        scope.popularButtons = [
          'COPILOT_BUTTON_IMPLEMENTATION_ASSISTANT', 'COPILOT_BUTTON_WORKFLOWS', 'COPILOT_BUTTON_SIGN_IN_METHOD', 'COPILOT_BUTTON_HELP'
        ];
        scope.siteManagerButtonNames = [
          'COPILOT_BUTTON_DISCOVER_PRINTERS', 'COPILOT_BUTTON_SEARCH_PRINTERS', 'COPILOT_BUTTON_TECHNICAL_SUPPORT', 'COPILOT_BUTTON_HELP'
        ];

        // Note that this is an object because as just a string, it wasn't updating the input field
        scope.currentUserMessage = { message: '' };
        scope.chatHistory = [];
        scope.copilotService = CopilotService;

        let isPartnerTenant = false;
        let chatWindow = angular.element('[chat-window]')[0];

        const chatWindowSizeObserver = new ResizeObserver(entries => {
          for (const entry of entries) {
            // entry.target is the element being observed
            // entry.contentRect provides the new dimensions of the element
            const { width, height } = entry.contentRect;
            CopilotService.state.copilotWidth = width;
          }
        });

        // Watch for changes to $rootScope.currentUser so we can set the name and initials
        $rootScope.$watch('currentUser', function (newValue) {
          if ($rootScope.currentUser) {
            scope.me = $rootScope.currentUser;
          }
          if (scope.userFirstName !== null) {
            return;
          }
          const name = newValue?.info?._embedded?.user?.name?.trim();
          if (!name) {
            return; // Exit if name is empty
          }
          const nameParts = name.split(' ').filter(part => part.length > 0);
          let userInitials = '';
          for (let i = 0; i < nameParts.length; i++) {
            userInitials += nameParts[i].charAt(0);
          }
          scope.userFirstName = nameParts[0]; // Assign first name or entire name if single-word
          scope.userInitials = userInitials.toUpperCase();
          scope.chatHistory = [];
          updateInitialMessage(scope);
        });

        // Watch for changes to the enabled and configured states so we can properly reset the initial messages.
        scope.$watch(function () {
          return [CopilotService.state.enabled, CopilotService.state.configured];
        }, function (newValue, oldValue) {
          if (newValue[0] !== oldValue[0] || newValue[1] !== oldValue[1]) {
            scope.chatHistory = [];
          }
          updateInitialMessage(scope);
        }, true);

        // Watch for changes to CopilotService.state.chatOpen.
        // Show the configuration dialog if Copilot is requested and not configured.
        // Set focus to the input field when Copilot becomes active
        scope.$watch(function () {
          return CopilotService.state.chatOpen;
        }, function (newValue, oldValue) {
          if (newValue && !oldValue) {
            updateInitialMessage(scope);
            if (!CopilotService.state.configured) {
              CopilotService.setConfigurationOpen(true);
            } else {
              scope.focusInput();
            }
            chatWindow = angular.element('[chat-window]')[0];
            if (chatWindow) {
              chatWindowSizeObserver.observe(chatWindow);
            }
          }
          if (!newValue && chatWindow) {
            chatWindowSizeObserver.unobserve(chatWindow);
            CopilotService.state.copilotWidth = 0;
          }
        });

        scope.$watch(function () {
          return CopilotService.state.isConfigurationOpen;
        }, function (newValue, oldValue) {
          if (newValue && !oldValue &&
            !CopilotService.state.configured &&
            !$window.location.href.includes('settings?settingsSection=generativeAi')) {
            scope.selectedContextMenuItem = {
              title: 'ConfigureGenerativeAi', type: 'configureGenerativeAi', name: 'ConfigureGenerativeAi'
            };
            CopilotService.setChatOpen(true);
          }
        });

        scope.closeAllMenus = function () {
          scope.selectedContextMenuItem = null;
        };

        scope.$watch(function () {
          return TenantListService.currentTenant;
        }, function () {
          if (TenantListService.currentTenant) {
            const currentTenant = TenantListService.currentTenant;
            isPartnerTenant = (currentTenant.info._links['px:salesPartner'] &&
              currentTenant.info._links['px:servicePartner']);
          }
        });

        scope.focusInput = function () {
          $timeout(function () {
            const inputElement = element[0].querySelector('[focus-target]');
            if (inputElement) {
              inputElement.focus();
            }
          }, 100);
        };

        scope.scrollToBottom = function () {
          $timeout(function () {
            // Using scrollTop instead of scrollIntoView because it is more reliable.
            const scrollToElement = element[0].querySelector('[scroll-target]');
            const scrollContainer = element[0].querySelector('[scroll-container]');
            if (scrollToElement && scrollContainer) {
              scrollContainer.scrollTop = scrollToElement.offsetTop;
            }
          }, 100);
        };

        scope.addMessage = function (newMessage) {
          if (newMessage.buttons === undefined) newMessage.buttons = [];
          if (newMessage.searchResults === undefined) newMessage.searchResults = [];

          scope.chatHistory.push(newMessage);
          scope.scrollToBottom();
        };

        scope.handleCopilotTyping = function (event) {
          if (event && (event.keyCode !== 13 || event.shiftKey || event.ctrlKey || event.altKey)) {
            return;
          }

          const newMessageText = scope.currentUserMessage.message.trim();
          if (newMessageText === '') {
            return;
          }

          scope.sendUserMessage(newMessageText, scope);
        };

        scope.hideUnpopularButtons = function (buttons) {
          return buttons.forEach(function (button) {
            if (!scope.popularButtons.includes(button.name)) {
              button.isHidden = true;
            }
          });
        };

        scope.sortByPopularButtons = function (buttons) {
          buttons.sort(function (a, b) {
            let indexA = scope.popularButtons.indexOf(a.name);
            let indexB = scope.popularButtons.indexOf(b.name);

            if (indexA === -1) indexA = Infinity;
            if (indexB === -1) indexB = Infinity;

            return indexA - indexB;
          });

        };

        scope.handleShowMoreButtonsClick = function (message, isLastMessage = false) {
          let hasHiddenButtons = false;
          for (let i = 0; i < message.buttons.length; i++) {
            message.buttons[i].isHidden = false;
            hasHiddenButtons = true;
          }
          message.hasMoreButton = false;
          if (hasHiddenButtons && isLastMessage) {
            scope.scrollToBottom();
          }
        };

        scope.sendUserMessage = function (newMessageText, scope) {
          // Save the user typed message and clear it
          const newMessage = {
            isUser: true,
            messages: [newMessageText]
          };
          scope.addMessage(newMessage);
          scope.currentUserMessage = { message: '' };

          // Process the user message
          scope.showChatWait = true;
          scope.addMessage({ isUser: false, isThinking: true, messages: [], buttons: [], searchResults: [] });

          CopilotService.requestGenerativeAiResponse(newMessageText)
            .then(function (requestedAction) {
              if (requestedAction.userRequest) newMessage.messages = [requestedAction.userRequest];
              scope.respondToRequestedAction(requestedAction);
            })
            .catch(function (error) {
              const isRateLimited = error?.status === 429;
              const retryAfterSeconds = error?.data.backoffMs / 1000;
              const retryAfterMinutes = Math.ceil(retryAfterSeconds / 60);
              const messageText = isRateLimited
                ? retryAfterMinutes <= 2
                  ? $filter('translate')('CopilotServerErrorRateLimitedFew')
                  : $filter('stringular')($filter('translate')('CopilotServerErrorRateLimited'), retryAfterMinutes)
                : $filter('translate')('CopilotServerError');
              const requestedAction = {
                ...CopilotConstants.emptyRequestedAction,
                responseType: 'UNKNOWN',
                errorMessage: messageText,
                userRequest: newMessageText
              };
              scope.respondToRequestedAction(requestedAction);
            })
            .finally(function () {
              scope.chatHistory = scope.chatHistory.filter(message => !message.isThinking);
              scope.showChatWait = false;
              scope.focusInput();
            });
        };

        scope.respondToRequestedAction = function (requestedAction) {

          const newMessage = {
            isUser: false,
            messages: [$filter('translate')(`COPILOT_RESPONSE_${requestedAction.responseType}`)]
          };
          let doNavigate = true;

          if (CopilotService.state.isFormDirty) {
            newMessage.messages = [($filter('translate')('CopilotUnsavedChanges'))];
            newMessage.buttons = [{
              text: $filter('translate')('CopilotTryAgain'),
              isRetry: true,
              showMoreButtons: false,
              requestedAction: { ...CopilotConstants.emptyRequestedAction, ...{ responseType: 'RETRY', userRequest: requestedAction.userRequest } }
            }];
          } else {
            const taskButtons = EnumerationService.rawEnums
              .reduce((acc, enumType) => {
                if (enumType.name === 'GenaiAdminChatAction') {
                  return enumType.values;
                }
                return acc;
              }, [])
              .filter(responseType => responseType !== 'UNKNOWN')
              .map(responseType => {
                const buttonText = $filter('translate')(`COPILOT_BUTTON_${responseType}`);
                return {
                  text: buttonText,
                  isHidden: false,
                  name: `COPILOT_BUTTON_${responseType}`,
                  requestedAction: { ...CopilotConstants.emptyRequestedAction, ...{ responseType, userRequest: buttonText } }
                };
              });
            scope.sortByPopularButtons(taskButtons);
            switch (requestedAction.responseType) {
              case 'SUBSCRIPTION':
                newMessage.messages = [$filter('translate')(isPartnerTenant
                  ? 'COPILOT_RESPONSE_SUBSCRIPTION_PARTNER'
                  : 'COPILOT_RESPONSE_SUBSCRIPTION')];
                break;
              case 'SITES':
                if (requestedAction.siteName) {
                  newMessage.messages = [$filter('translate')('COPILOT_RESPONSE_SITES_WITH_PARAM')];
                }
                break;
              case 'DISCOVER_PRINTERS':
                if (requestedAction.discoverOnNetworkName) {
                  newMessage.messages = [$filter('translate')('COPILOT_RESPONSE_DISCOVER_PRINTERS_WITH_PARAM')];
                }
                break;
              case 'SEARCH_PRINTERS':
                if (requestedAction.printerSearchString) {
                  newMessage.messages = [$filter('translate')('COPILOT_RESPONSE_SEARCH_PRINTERS_WITH_PARAM')];
                }
                break;
              case 'ADD_USER':
                if (requestedAction.userParameters.email || requestedAction.userParameters.role) {
                  newMessage.messages = [$filter('translate')('COPILOT_RESPONSE_ADD_USER_WITH_PARAM')];
                }
                break;
              case 'NETWORKS':
                if (requestedAction.newNetworkName) {
                  newMessage.messages = [$filter('translate')('COPILOT_RESPONSE_NETWORKS_WITH_PARAM')];
                }
                break;
              case 'CLOUD_STORAGE':
                if (requestedAction.cloudStorageParameters.name || requestedAction.cloudStorageParameters.type) {
                  newMessage.messages = [$filter('translate')('COPILOT_RESPONSE_CLOUD_STORAGE_WITH_PARAM')];
                }
                break;
              case 'HELP':
                // If there was a search query and we should display results, update the response and add the relevant buttons
                if (requestedAction.helpResults !== undefined && requestedAction.helpResults.displayResults) {
                  doNavigate = false;
                  newMessage.searchResults = requestedAction.helpResults.searchResults;
                  if (requestedAction.helpResults.totalSearchResultsCount === 0) {
                    newMessage.messages = [$filter('translate')('COPILOT_RESPONSE_HELP_NOT_FOUND')];
                    newMessage.buttons = taskButtons;
                  } else {
                    newMessage.messages = [$filter('translate')('COPILOT_RESPONSE_HELP_WITH_PARAM')];
                    if (requestedAction.helpResults.totalSearchResultsCount > 3) {
                      const buttonText = $filter('translate')('COPILOT_BUTTON_HELP_MORE_RESULTS');
                      newMessage.buttons = [{
                        text: buttonText,
                        requestedAction: {
                          ...CopilotConstants.emptyRequestedAction,
                          ...{
                            responseType: 'HELP',
                            userRequest: buttonText,
                            helpResults: {
                              ...CopilotConstants.emptyRequestedAction.helpResults,
                              queryString: requestedAction.helpResults.queryString
                            }
                          }
                        }
                      }];
                    } else {
                      newMessage.buttons = taskButtons.filter(button => button.requestedAction.responseType === 'HELP');
                    }
                  }
                }
                break;
              case 'UNKNOWN':
                handleResponseTypeUnknown(requestedAction, newMessage, taskButtons);
                break;
              case 'CONFIGURE_AI':
                if (!$window.location.href.includes('settings?settingsSection=generativeAi')) {
                  scope.selectedContextMenuItem = {
                    title: 'ConfigureGenerativeAi', type: 'configureGenerativeAi', name: 'ConfigureGenerativeAi'
                  };
                  return;
                }
                break;
            }
          }

          scope.addMessage(newMessage);
          if (doNavigate) {
            CopilotService.navigate(requestedAction);
          }
        };

        scope.onMessageButtonClick = function (button) {
          CopilotService.state.requestedAction = button.requestedAction;
          if (button.requestedAction.responseType === 'RETRY') {
            scope.sendUserMessage(button.requestedAction.userRequest, scope);
          } else {
            if (button.requestedAction.userRequest) {
              scope.addMessage({ isUser: true, messages: [button.requestedAction.userRequest] });
            }
            scope.respondToRequestedAction(button.requestedAction);
          }
        };

        scope.$on('$destroy', function () {
          // Stop observing on scope destruction to prevent memory leaks
          if (chatWindow) {
            chatWindowSizeObserver.unobserve(chatWindow);
          }
        });

        function handleResponseTypeUnknown(requestedAction, newMessage, taskButtons) {
          if (scope.me.isSystemManager() || scope.me.hasPrimaryRole('PRINTIX_MANAGER') || scope.me.hasPrimaryRole('PRINTIX_SUPPORTER')) {
            scope.hideUnpopularButtons(taskButtons);
            newMessage.buttons = taskButtons;
            newMessage.hasMoreButton = true;
          } else if (scope.me.isSiteManager()) {
            hideNonSiteManagerButtons(taskButtons);
            newMessage.buttons = taskButtons;
          } else if (scope.me.isSystemObserver()) {
            newMessage.messages = [$filter('translate')('CopilotHelpSearchOnlineDocumentation')];
          }
          if (requestedAction.errorMessage) {
            newMessage.messages = [requestedAction.errorMessage];
            const tryAgainButton = {
              text: $filter('translate')('CopilotTryAgain'),
              isRetry: true,
              requestedAction: { ...CopilotConstants.emptyRequestedAction, ...{ responseType: 'RETRY', userRequest: requestedAction.userRequest } }
            };
            if (newMessage.buttons) {
              newMessage.buttons.push(tryAgainButton);
            } else {
              newMessage.buttons = [tryAgainButton];
            }
          }
        }

        function hideNonSiteManagerButtons(buttons) {
          buttons.forEach(function (button) {
            if (!scope.siteManagerButtonNames.includes(button.name)) {
              button.isHidden = true;
            }
          });
        }

      }
    };

    function updateInitialMessage(scope) {
      if (scope.chatHistory.length === 0) {
        const welcomeUserMessage = $filter('stringular')($filter('translate')('CopilotWelcomeUser'), scope.userFirstName);
        if (CopilotService.state.configured) {
          const welcomeMessage = getWelcomeMessageForUser(scope.me);
          scope.addMessage({
            isUser: false,
            messages: [welcomeUserMessage, welcomeMessage]
          });
        } else {
          const welcomeMessage = $filter('translate')('CopilotWelcomeNotConfigured');
          scope.addMessage({
            isUser: false,
            messages: [welcomeUserMessage, welcomeMessage],
            buttons: [{
              text: ($filter('translate')('CopilotConfigureButton')),
              hideIfConfigurationOpen: true,
              requestedAction: { ...CopilotConstants.emptyRequestedAction, ...{ responseType: 'CONFIGURE_AI' } }
            }]
          });
        }
      }
    }

    function getWelcomeMessageForUser(me) {
      let welcomeMessage = '';
      if (me) {
        if (me.isSystemManager() || me.hasPrimaryRole('PRINTIX_MANAGER') || me.hasPrimaryRole('PRINTIX_SUPPORTER')) {
          welcomeMessage = 'CopilotWelcome';
        } else if (me.isSiteManager()) {
          welcomeMessage = 'CopilotWelcomeSiteManager';
        } else if (me.isSystemObserver()) {
          welcomeMessage = 'CopilotWelcomeSystemObserver';
        }
      }
      if (welcomeMessage) {
        welcomeMessage = $filter('translate')(welcomeMessage).replace('</br>', '\n');
      }
      return welcomeMessage;
    }
  }

  pxCopilotDirective.$inject = ['$filter', '$location', '$rootScope', '$timeout', '$window', 'CopilotService', 'EnumerationService', 'CopilotConstants', 'TenantListService'];

  angular
    .module('printix-admin')
    .directive('pxCopilotDirective', pxCopilotDirective);

})();
